document.addEventListener('DOMContentLoaded', function() {
    // Run this script on the DTF Printers collection page (adjust if needed)
    if (window.location.pathname.startsWith('/collections/dtf-printers')) {
        initFinanceButtons();
        observeProductChanges();
    }
});

function initFinanceButtons() {
    // --- CONFIGURATION ---
    const ANNUAL_INTEREST_RATE = 0;  // 0% for 12-Month Same As Cash
    const PRICE_THRESHOLD = 2000;    // Show button only if price > $2,000
    const DEFAULT_TERM_MONTHS = 24;  // Default term (24, 36, or 48—up to you)

    // Tooltip text: you can adjust this HTML as you like
    const tooltipContent = `
        <strong>12-Month Same As Cash Program</strong><br><br>
        <em>Here's how it works:</em><br>
        • Every approval includes the 12-Month Same As Cash option (not applicable in NY or KS).<br>
        • You initially pick a 24, 36, or 48-month term.<br>
        • If you pay the full invoice amount before the 12th payment, you pay <strong>0% interest</strong>.<br>
        • After the 12th payment, you revert to the full term you selected.<br><br>
       
    `;

    // Find all price elements in the collection (adjust selector if needed)
    const priceElements = document.querySelectorAll('.yv-product-price');
    if (priceElements.length === 0) {
        console.warn('No price elements found in the DTF Printers collection.');
        return;
    }

    priceElements.forEach(function(priceElement) {
        // 1) Identify the container for each product
        const productContainer = priceElement.closest('.product-item') || priceElement.parentNode;

        // 2) Check if a finance button already exists here
        if (productContainer.querySelector('.finance-button')) {
            return; // Skip—no duplicates
        }

        // 3) Extract numeric price
        const priceText = priceElement.textContent.trim().replace('From', '');
        const priceValue = parseFloat(priceText.replace(/[^0-9.]/g, ''));
        if (isNaN(priceValue) || priceValue < PRICE_THRESHOLD) {
            return; // Skip if price is invalid or below threshold
        }

        // 4) Calculate monthly payment
        const monthlyInterestRate = (ANNUAL_INTEREST_RATE / 100) / 12;
        let financeAmount;
        if (monthlyInterestRate === 0) {
            // For 0% interest, just divide the total by the term
            financeAmount = (priceValue / DEFAULT_TERM_MONTHS).toFixed(2);
        } else {
            // Standard finance formula
            financeAmount = (
                priceValue *
                monthlyInterestRate *
                Math.pow(1 + monthlyInterestRate, DEFAULT_TERM_MONTHS) /
                (Math.pow(1 + monthlyInterestRate, DEFAULT_TERM_MONTHS) - 1)
            ).toFixed(2);
        }

        // 5) Create a wrapper to hold the button + tooltip
        const tooltipWrapper = document.createElement('div');
        tooltipWrapper.style.position = 'relative';
        tooltipWrapper.style.display = 'inline-block';

        // 6) Create the finance button
        const financeButton = document.createElement('button');
        financeButton.classList.add('finance-button');
        financeButton.textContent = `Finance from $${financeAmount}/mo — 12-Month Same As Cash!`;
        financeButton.style.cssText = `
            font-size: 11px;
            background-color: #ff1493; /* Pink */
            color: #FFFFFF;
            border: none;
            border-radius: 4px;
            padding: 5px 10px;
            margin-top: 6px;
            cursor: pointer;
            font-family: 'Nunito Sans', sans-serif;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            transition: transform 0.2s, background-color 0.2s;
            display: inline-flex;
            align-items: center;
        `;
        // Hover effect
        financeButton.addEventListener('mouseover', function() {
            financeButton.style.backgroundColor = '#e6007e'; 
            financeButton.style.transform = 'translateY(-1px)';
            financeButton.textContent = 'Learn more & apply now!';
        });
        financeButton.addEventListener('mouseout', function() {
            financeButton.style.backgroundColor = '#ff1493'; 
            financeButton.style.transform = 'translateY(0)';
            financeButton.textContent = `Finance from $${financeAmount}/mo — 12-Month Same As Cash!`;
        });
        // Click event -> open application link
        financeButton.addEventListener('click', function() {
            window.location.href = 'https://secure.financ.ing/app?dealercode=VV225&apptype=B&qs=apply';
        });

        // 7) Create the tooltip bubble
        const tooltipBubble = document.createElement('div');
        tooltipBubble.innerHTML = tooltipContent; // we can store HTML here
        tooltipBubble.style.cssText = `
            visibility: hidden;
            width: 250px;
            background-color: #ffffff;
            color: #333333;
            text-align: left;
            border-radius: 4px;
            padding: 10px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
            position: absolute;
            z-index: 9999;
            bottom: 130%;
            left: 50%;
            transform: translateX(-50%);
            opacity: 0;
            transition: opacity 0.2s;
            font-size: 12px;
            line-height: 1.4;
        `;
        // Tooltip arrow
        const tooltipArrow = document.createElement('div');
        tooltipArrow.style.cssText = `
            position: absolute;
            top: 100%;
            left: 50%;
            transform: translateX(-50%);
            border-width: 6px;
            border-style: solid;
            border-color: #ffffff transparent transparent transparent;
        `;
        tooltipBubble.appendChild(tooltipArrow);

        // 8) Show/hide tooltip on hover
        tooltipWrapper.addEventListener('mouseenter', function() {
            tooltipBubble.style.visibility = 'visible';
            tooltipBubble.style.opacity = '1';
        });
        tooltipWrapper.addEventListener('mouseleave', function() {
            tooltipBubble.style.visibility = 'hidden';
            tooltipBubble.style.opacity = '0';
        });

        // 9) Put everything in place
        tooltipWrapper.appendChild(financeButton);
        tooltipWrapper.appendChild(tooltipBubble);
        productContainer.appendChild(tooltipWrapper);
    });
}

/**
 * Observes for dynamically loaded products (via AJAX, infinite scroll, etc.)
 * and re-runs initFinanceButtons(), which safely skips duplicates.
 */
function observeProductChanges() {
    // Adjust if your product container uses a different class
    const productContainer = document.querySelector('.product-grid') 
                          || document.querySelector('.products') 
                          || document.body;
    
    if (!productContainer) {
        console.warn('Product container not found. Finance buttons may not initialize correctly.');
        return;
    }

    const observer = new MutationObserver(function(mutationsList) {
        for (let mutation of mutationsList) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                // Re-run after a small delay so elements are fully loaded
                setTimeout(initFinanceButtons, 500);
            }
        }
    });

    observer.observe(productContainer, { childList: true, subtree: true });
}
